const DEFAULT_PASSWORD_POLICY_MESSAGE = '비밀번호 정책을 확인해 주세요.'

const AUTH_ERROR_MESSAGES = {
  '1001121': '로그인 시도 횟수가 너무 많습니다. 잠시 후 다시 시도해주세요.',
  '1001185': '비밀번호 인증이 비활성화되었습니다. 비밀번호를 초기화해 주세요.',
}

export function getTokenPayload(data = {}) {
  return data && data.token ? data.token : data || {}
}

export function getAccessTokenFromResponse(data = {}) {
  const token = getTokenPayload(data)
  return token.access_token || token.accessToken || ''
}

export function getRefreshTokenFromResponse(data = {}) {
  const token = getTokenPayload(data)
  return token.refresh_token || token.refreshToken || ''
}

export function shouldStoreRefreshToken(authRefreshMode = 'legacy') {
  return authRefreshMode !== 'cookie'
}

export function getAuthErrorData(errorOrData = {}) {
  return errorOrData && errorOrData.response && errorOrData.response.data
    ? errorOrData.response.data
    : errorOrData || {}
}

export function normalizeAuthErrorCode(errorOrData = {}) {
  const data = getAuthErrorData(errorOrData)
  return data.err_code === undefined || data.err_code === null ? '' : String(data.err_code)
}

export function getPasswordPolicyMessage(errorOrData = {}) {
  const data = getAuthErrorData(errorOrData)
  if (data.err_msg) return data.err_msg

  const firstPasswordError = Array.isArray(data.password_errors) ? data.password_errors[0] : null
  return (firstPasswordError && (firstPasswordError.message || firstPasswordError)) || DEFAULT_PASSWORD_POLICY_MESSAGE
}

export function getPasswordLengthError(password = '') {
  if (password.length < 15) return '비밀번호는 15자 이상 입력해 주세요.'
  if (password.length > 64) return '비밀번호는 64자 이하로 입력해 주세요.'
  return ''
}

export function getAuthErrorMessage(errorOrData = {}) {
  const code = normalizeAuthErrorCode(errorOrData)
  if (code === '1001184') return getPasswordPolicyMessage(errorOrData)
  return AUTH_ERROR_MESSAGES[code] || ''
}
